import cn from 'classnames';

import Icon from 'components/icon/Icon';

interface ThWithSortProps {
  onClick: () => void;
  sortDirection: boolean | undefined;
}

const ThWithSort: React.FC<React.PropsWithChildren<ThWithSortProps>> = ({ children, onClick, sortDirection }) => (
  <th aria-sort={sortDirection === undefined ? undefined : sortDirection ? 'ascending' : 'descending'}>
    <button
      className={cn('table__header-button', { 'table--hover-trigger': sortDirection === undefined })}
      onClick={onClick}
      type="button"
    >
      <div className="table__header-item">
        {children}
        <Icon
          className={cn('table__sort-icon', {
            'table__sort-icon--is-active': sortDirection !== undefined && !sortDirection
          })}
          name="sort-down"
          fill
        />
      </div>
    </button>
  </th>
);

ThWithSort.displayName = 'ThWithSort';

export default ThWithSort;
